<template>
  <v-dialog
      class="hide-on-print"
      persistent
      v-model="innerOpen"
      width="800">
    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark v-if="step===1">
        <v-toolbar-title>Generate tippani</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex :class="{'hide':step ===2}" xs12>
              <v-form class="pa-2" lazy-validation ref="formRef">
                <v-layout row wrap>
                  <v-flex class="py-0" xs12>
                    <v-autocomplete
                        :items="tippanis"
                        @change="fillTippani"
                        item-text="name"
                        item-value="id"
                        label="Tippani type"
                        outlined
                        v-model="selectedTippani"
                    />
                  </v-flex>
                  <v-flex class="py-0" xs12>
                    <div :class="{'hide':hide}">
                      <div id="editor"></div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <v-flex :class="{'hide':step ===1}">
              <extend-convert-tippani-print-content/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancelTippani" class="white--text" color="red lighten-1">
          Cancel
        </v-btn>
        <v-btn
            @click="proceed"
            class="white--text"
            color="blue darken-3 "
            v-if="step===1"
        >
          Proceed
        </v-btn>
        <v-btn
            @click="print('initial_tippani')"
            class="white--text"
            color="blue darken-3"
            v-if="step === 2"
        >Print
        </v-btn>
        <v-btn
            @click="save"
            class="white--text"
            v-if="showSaveButton"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ExtendConvertTippaniPrintContent from "../visa/ExtendConvertTippaniPrintContent";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {GET_TIPPANI} from "../../store/action-type";
import moment from "moment";
import {SET_GENERATED_TIPPANI, SET_PRINT_CONTENT} from "../../store/mutation-type";
import {mapActions} from "vuex";

export default {
  name: "VisaTippaniDialog",
  components: {
    ExtendConvertTippaniPrintContent
  },
  props: ['value'],
  data() {
    return {
      innerOpen: false,
      step: 1,
      selectedTippani: false,
      hide: false,
      quill: false
    }
  },
  computed: {
    latest_status() {
      const latest_status = this.visa_request.visaHistory[0];
      let deleted_tracks = this.visa_request.visaHistory.filter(
          (i) => i.deletable && i.deleted_at > latest_status.created_at
      );

      if (deleted_tracks.length > 0) {
        deleted_tracks.sort(
            (a, b) => Date.parse(b.deleted_at) - Date.parse(a.deleted_at)
        );
        return deleted_tracks[0].status + " Removed";
      }
      return latest_status.status;
    },
    visa_request() {
      return this.$store.state.VisaRequestSingle.visaRequest;
    },
    tippanis() {
      return this.$store.state.Tippani.tippanis;
    },
    showSaveButton() {
      if (this.visa_request.submission_no.toLowerCase().substr(0, 1) === 'v' && this.step === 2)
        return true;

      return (this.step === 2 && !this.visa_request.voucher_generated) || (this.step === 2 && this.latest_status === 'Tippani Generated Removed');
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    }
  },
  methods: {
    cancelTippani() {
      if (this.step === 1) {
        this.innerOpen = false;
        this.$emit('input', false)
      } else {
        this.hide = false;
        this.step = 1;
      }

    },
    proceed() {
      const tippani = this.quill.root.innerHTML;
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.hide = true;
      this.step = 2;
    },
    print() {
      const content = document.getElementById('tippani_content').innerHTML;
      this.$store.commit(SET_PRINT_CONTENT, content)
    },
    async save() {
      await this.$dialog.confirm({
        text: "Are you sure want to save tippani ? Tippani once saved cannot edit.",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.$store.dispatch('VisaRequestSingle/submitTippani', {
                content: this.quill.root.innerHTML,
                overstay_penalty: this.visa_request.overstayPenalty,
                late_penalty: this.visa_request.latePenalty
              }).then(() => {
                this.$store.commit('Notification/showSuccess', 'Tippani generated successfully');
                this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.visa_request.submission_no)
                this.innerOpen = false;
                this.$emit('input', false)
                if (this.visa_request.automation_enabled) {
                  this.$store.dispatch('VisaRequestSingle/getOfficeWiseUser')
                  this.$emit('assignUser', true)
                }
              }).catch(error => {
                this.$store.commit('Notification/showError', error.response.data.message);
                this.innerOpen = false;
                this.$emit('input', false)
                return;
              })
            }
          }
        }
      });
    },
    fillTippani() {
      const {
        traveller,
        created_at,
        nepali_date,
        passport_number,
        duration, late_days,
        visa_type_condition,
        condition,
        previous_visa,
        visa_plan_name,
        start_date,
        verified_at,
        end_date,
        extra,
        visa_plan,
        payment_detail,
        dependent_visa
      } = this.visa_request;
      let tippani = null;
      tippani = this.tippanis.find(i => i.id === this.selectedTippani);
      tippani = tippani.text;
      tippani = tippani.replace('@applicant_name', traveller.full_name);
      tippani = tippani.replace('@applicant_country', traveller.country.country_name);
      tippani = tippani.replace('@application_date_en', created_at.substr(0, 10));
      tippani = tippani.replace('@application_date_np', nepali_date);
      tippani = tippani.replace('@passport_number', passport_number);
      tippani = tippani.replace('@requested_days', duration);
      tippani = tippani.replace('@late_days', late_days);
      let late_stay_cost = this.visa_request.payment_detail.late_stay_cost;
      let late_fine = '(' + this.visa_request.late_days + '*' + previous_visa.late_fee_per_day + '=' + late_stay_cost + ' )';
      let late_fee = '(' + this.visa_request.late_days + '*' + (previous_visa.late_fee_per_day + previous_visa.extend_fee_per_day) + '=' + late_stay_cost + ' )';
      tippani = tippani.replace('@late_fine', late_fine);
      tippani = tippani.replace('@visa_fee', payment_detail.amount);
      tippani = tippani.replace('@late_fee', late_fee);

      this.visa_request.visa_plan = parseInt(visa_plan);

      const visa_type_slug = visa_type_condition.visa_type.slug;

      const days_cost = this.visa_request.visa_type_condition.days_cost;
      let selected_day = {};
      for (let i = 0; i < days_cost.length; i++) {
        if (parseInt(days_cost[i].days) >= this.visa_request.duration) {
          selected_day = days_cost[i];
          break;
        }
      }
      selected_day.cost = parseInt(selected_day.cost);
      selected_day.days = parseInt(selected_day.days);
      let days = selected_day.days;
      let month = days === 365 ? 12 : days / 30;

      let fraction = month - Math.floor(month);
      if (visa_type_slug === 'working-visa' || visa_type_slug === 'study-visa') {
        if (fraction > 0) {
          month = fraction > 0.5 ? Math.floor(month) + 1 : Math.floor(month) + 0.5;
          console.log(month)
        }
      } else {
        month = month === 13 ? 12 : month;
      }
      let cost_per_month = selected_day.cost / month;

      let cost_string = '(';
      let amount = payment_detail.amount;
      cost_string = cost_string + ' ' + (visa_type_slug === 'working-visa' || visa_type_slug === 'study-visa') ? month + ' * ' + Math.ceil(cost_per_month) : Math.round(month) + ' * ' + Math.ceil(cost_per_month);


      // let cost =
      if (payment_detail.plan_charge > 0) {
        if (visa_type_slug !== 'business-visa')
          cost_string = cost_string + ' + ' + payment_detail.plan_charge;
      }
      let late_cost = 0;
      if (payment_detail.late_stay_cost > 0) {
        cost_string = cost_string + ' + ' + payment_detail.late_stay_cost;
        amount += payment_detail.late_stay_cost;
      }

      let exempt_cost = 0;
      if (payment_detail.exempt_cost > 0) {
        cost_string = cost_string + ' - ' + payment_detail.exempt_cost;
        amount -= payment_detail.exempt_cost;
      }
      let transfer_cost = 0;
      if (parseFloat(payment_detail.transfer_cost) > 0) {
        cost_string = cost_string + ' + ' + parseFloat(payment_detail.transfer_cost);
        amount += parseFloat(payment_detail.transfer_cost)
      }
      cost_string = cost_string + '=' + amount + ')';

      tippani = tippani.replace('@cost', cost_string);


      if (visa_type_slug === 'relation-visa') {
        tippani = tippani.replace('@kin_name', extra.extra_traveller.full_name);
        tippani = tippani.replace('@kin_relation', extra.application_data.relation);
        tippani = tippani.replace('@kin_address', extra.extra_traveller.full_address);
      } else if (visa_type_slug === 'nrn-visa') {
        tippani = tippani.replace('@nrn_card_expiry_date', extra.application_data.nrn_card_expiry_date);
        tippani = tippani.replace('@nrn_card_number', extra.application_data.nrn_card_number);
      } else if (visa_type_slug === 'marriage-visa') {
        tippani = tippani.replace('@kin_name', extra.extra_traveller.full_name);
        tippani = tippani.replace('@kin_address', extra.extra_traveller.full_address);
        tippani = tippani.replace('@date_of_marriage', extra.application_data.date_of_marriage);
        tippani = tippani.replace('@place_of_marriage', extra.application_data.place_of_marriage);
      } else if (visa_type_slug === 'dependent-study-visa') {
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
        tippani = tippani.replace('@host_name', dependent_visa && dependent_visa.full_name ? dependent_visa.full_name : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.full_name : 'N/A');
        tippani = tippani.replace('@host_passport_number', dependent_visa && dependent_visa.document_number ? dependent_visa.document_number : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.document_number : 'N/A');
        tippani = tippani.replace('@host_visa_detail', dependent_visa && dependent_visa.start_date && dependent_visa.expiry_date ? dependent_visa.start_date + ' to ' + dependent_visa.expiry_date + ' (' + dependent_visa.visa_number + ')' : 'N/A');
        tippani = tippani.replace('@host_latestvisaissue_date', dependent_visa && dependent_visa.approved_at ? moment(dependent_visa.approved_at).format('Y-M-D') : 'N/A');
      } else if (visa_type_slug === 'dependent-nrn-visa') {
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
        tippani = tippani.replace('@host_name', dependent_visa && dependent_visa.full_name ? dependent_visa.full_name : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.full_name : 'N/A');
        tippani = tippani.replace('@host_passport_number', dependent_visa && dependent_visa.document_number ? dependent_visa.document_number : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.document_number : 'N/A');
        tippani = tippani.replace('@host_visa_detail', dependent_visa && dependent_visa.start_date && dependent_visa.expiry_date ? dependent_visa.start_date + ' to ' + dependent_visa.expiry_date + ' (' + dependent_visa.visa_number + ')' : 'N/A');
        tippani = tippani.replace('@host_latestvisaissue_date', dependent_visa && dependent_visa.approved_at ? moment(dependent_visa.approved_at).format('Y-M-D') : 'N/A');
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
        tippani = tippani.replace('@host_name', dependent_visa.full_name);
        tippani = tippani.replace('@host_name', dependent_visa.full_name);
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
      } else if (visa_type_slug === 'dependent-working-visa') {
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
        tippani = tippani.replace('@host_name', dependent_visa && dependent_visa.full_name ? dependent_visa.full_name : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.full_name : 'N/A');
        tippani = tippani.replace('@host_passport_number', dependent_visa && dependent_visa.document_number ? dependent_visa.document_number : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.document_number : 'N/A');
        tippani = tippani.replace('@host_visa_detail', dependent_visa && dependent_visa.start_date && dependent_visa.expiry_date ? dependent_visa.start_date + ' to ' + dependent_visa.expiry_date + ' (' + dependent_visa.visa_number + ')' : 'N/A');
        tippani = tippani.replace('@host_latestvisaissue_date', dependent_visa && dependent_visa.approved_at ? moment(dependent_visa.approved_at).format('Y-M-D') : 'N/A');
      } else if (visa_type_slug === 'dependent-tr-visa') {
        tippani = tippani.replace('@host_relation', extra && extra.application_data && extra.application_data.relation ? extra.application_data.relation : 'N/A');
        tippani = tippani.replace('@host_name', dependent_visa && dependent_visa.full_name ? dependent_visa.full_name : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.full_name : 'N/A');
        tippani = tippani.replace('@host_passport_number', dependent_visa && dependent_visa.document_number ? dependent_visa.document_number : extra.application_data && extra.application_data.traveller ? extra.application_data.traveller.document_number : 'N/A');
        tippani = tippani.replace('@host_visa_detail', dependent_visa && dependent_visa.start_date && dependent_visa.expiry_date ? dependent_visa.start_date + ' to ' + dependent_visa.expiry_date + ' (' + dependent_visa.visa_number + ')' : 'N/A');
        tippani = tippani.replace('@host_latestvisaissue_date', dependent_visa && dependent_visa.approved_at ? moment(dependent_visa.approved_at).format('Y-M-D') : 'N/A');
      } else if (visa_type_slug === 'business-visa') {
        tippani = tippani.replace('@business_name', extra && extra.application_data && extra.application_data.name_of_business_institute ? extra.application_data.name_of_business_institute : 'N/A')
      }

      tippani = tippani.replace('@previous_visa_condition', previous_visa.visa_type_condition);
      tippani = tippani.replace('@previous_visa_type', previous_visa.visa_type);
      tippani = tippani.replaceAll('@previous_expiry_date', previous_visa.expiry_date);
      tippani = tippani.replaceAll('@previous_start_date', previous_visa.start_date);
      tippani = tippani.replace('@requested_visa_type', visa_type_condition.visa_type.name);
      tippani = tippani.replace('@requested_visa_condition', condition);
      tippani = tippani.replace('@previous_visa_number', previous_visa.visa_number);
      tippani = tippani.replace('@visa_plan', visa_plan_name);
      tippani = tippani.replaceAll('@visa_end_date', moment(end_date).subtract('1', 'days').format('YYYY-MM-DD'));
      tippani = tippani.replaceAll('@visa_start_date', start_date.substr(0, 10));
      tippani = tippani.replace('@application_verified_date', verified_at ? verified_at.substr(0, 10) : null);
      tippani = tippani.replaceAll('@previous_expiry_day_next', moment(previous_visa.expiry_date).add('1', 'days').format('YYYY-MM-DD'));

      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.quill.root.innerHTML = tippani;

    }
  },
  async mounted() {
    if (this.value) {
      this.innerOpen = this.value;
    }
    if (this.quill)
      this.quill.root.innerHTML = null;

    setTimeout(() => {

      if (!this.quill)
        this.quill = new Quill('#editor', {
          theme: 'snow',
          modules: {
            toolbar: [
              [{header: [1, 2, false]}],
              ['bold', 'italic', 'underline'],
            ],
          },
        });
    }, 200);
    await this.$store.dispatch(GET_TIPPANI, this.visa_request.visaType.id);
  }
}
</script>
